import { useState } from 'react'
import * as S from './styled'

import { Icon } from '../Icon'
import { Button } from '../Button'

import { useTranslation } from 'react-i18next'

export type ModalProps = {
  cancelTitle?: string
  cancelButton?: boolean
  width?: number | string
  content: JSX.Element
  button?: JSX.Element
  isActionsEnabled?: boolean
  height?: number | string
  isPersonButtons?: boolean
  onExit?: () => void
}

const Modal = ({
  cancelButton = true,
  width = 60,
  height = 'auto',
  content,
  button,
  isPersonButtons,
  isActionsEnabled = true,
  onExit
}: ModalProps) => {
  const { t } = useTranslation()
  const [isOpen, setIsOpen] = useState(true)

  function setModalClose() {
    setIsOpen(false)
    !!onExit && onExit()
  }

  let actions: JSX.Element

  if (isPersonButtons) {
    actions = button
  } else if (isActionsEnabled) {
    actions = (
      <S.ActionButtons>
        <div>
          {cancelButton && (
            <Button variant="default" onClick={setModalClose} size="medium">
              <p>{t('common:cancel')}</p>
            </Button>
          )}
          {button}
        </div>
      </S.ActionButtons>
    )
  } else {
    actions = <S.ActionButtons data-testid="no-actions"></S.ActionButtons>
  }

  return (
    <S.Background isOpen={isOpen}>
      <S.Wrapper isOpen={isOpen}>
        <S.Modal
          height={height}
          width={width}
          isOpen={isOpen}
          data-testid="modal"
          aria-label="modal"
          aria-hidden={!isOpen}
        >
          <S.Close
            data-testid="close-modal"
            aria-label="close-modal"
            onClick={setModalClose}
          >
            <Icon icon="modal-exit" height={16} width={16} />
          </S.Close>
          <S.Template>
            <S.Content>{content}</S.Content>
            <S.Actions className={'actions'}>
              <S.Line />
              {actions}
            </S.Actions>
          </S.Template>
        </S.Modal>
      </S.Wrapper>
    </S.Background>
  )
}

export default Modal
